import "./widgets/search/search_widget";
import "./widgets/search/search_panel";
import "./widgets/timeline/timeline";
import "./widgets/masterresult";
import "./widgets/dashboard/dashboard";

//    "./widgets/people",
//    "./widgets/actions",
import "./widgets/userview";

import "./widgets/indicators/indicator";
import "./widgets/indicators/indicator_list";
import "./widgets/calendar";
import "./widgets/charts/chart";
import "./widgets/map";
import "./widgets/static_html";
import "./widgets/details";
import "./widgets/search/fixed_search";
